import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {
  EmbeddingAugmentorResultDTO,
  EmbeddingDTO,
  PaperHasEmbeddingDTO,
  ProjectHasEmbeddingOverviewDTO
} from '../dto/embedding';
import {Observable, throwError} from 'rxjs';
import {PaperChatFilterType} from '../dto/paper-chat';
import {catchError, map} from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class EmbeddingService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly apiUrl = environment.apiBaseUrl + '/embeddings';

  checkAndCreatePaperEmbedding(paperId: number): Observable<boolean> {
    const url = `${this.apiUrl}/papers/${paperId}/check-and-create-embedding`;
    return this.http.get(url, { observe: 'response' }).pipe(
      map((response: HttpResponse<any>) => {
        if (response.status === 200) {
          return true; // Has Embedding
        } else if (response.status === 204) {
          return false; // Does not have Embedding
        }
        return false;
      }),
      catchError(error => {
        return throwError(() => error);
      })
    );
  }

  getAllEmbeddingsForProject(projectId: number): Observable<EmbeddingDTO[]> {
    if (!projectId) {
      throw new Error('ProjectId is required');
    }
    const url = `${this.apiUrl}/projects/${projectId}`;
    return this.http.get<EmbeddingDTO[]>(url);
  }

  hasAllPaperEmbedding(projectId: number, filter?: PaperChatFilterType): Observable<PaperHasEmbeddingDTO[]> {
    if (!projectId) {
      throw new Error('ProjectId is required');
    }
    const url = `${this.apiUrl}/projects/${projectId}/has-embedding`;
    if (!filter) {
      filter = PaperChatFilterType.ALL;
    }
    const params = new HttpParams().set('filter', filter);
    return this.http.get<PaperHasEmbeddingDTO[]>(url, {params});
  }

  deleteUserEmbedding(): Observable<Object> {
    return this.http.delete(this.apiUrl);
  }

  projectEmbeddingOverview(projectId: number): Observable<ProjectHasEmbeddingOverviewDTO> {
    if (!projectId) {
      throw new Error('ProjectId is required');
    }
    const url = `${this.apiUrl}/projects/${projectId}/overview`;
    return this.http.get<ProjectHasEmbeddingOverviewDTO>(url);
  }

  getAllEmbeddingsForPaper(paperId: number): Observable<EmbeddingDTO[]> {
    if (!paperId) {
      throw new Error('ProjectId is required');
    }
    const url = `${this.apiUrl}/papers/${paperId}`;
    return this.http.get<EmbeddingDTO[]>(url);
  }

  queryEmbedding(projectId: number, query: string): Observable<EmbeddingAugmentorResultDTO[]> {
    if (!projectId) {
      throw new Error('ProjectId is required');
    }
    if (!query) {
      throw new Error('Query is required');
    }
    const url = `${this.apiUrl}/query/${projectId}`;
    const params = new HttpParams().set('query', query);
    return this.http.get<EmbeddingAugmentorResultDTO[]>(url, {params});
  }
}
